// extracted by mini-css-extract-plugin
module.exports = {"pagination":"WB","pageSize":"XB","disabled":"YB","pageGroups":"ZB","pageGroup":"_B","currentPage":"aC","previousPage":"bC","nextPage":"cC"};